import { Box } from '@chakra-ui/react';
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { ValleyBankTemplate } from 'valleyBank/domains/page/ui/ValleyBankTemplate';
import { Route as SettingsUserRoute } from '~/core/routes/settings/my-account/_index';

export const SettingsRouter = () => {
  return (
    <ValleyBankTemplate>
      {/* Paths relative to "/settings/*"  */}

      <Routes>
        <Route
          path="/my-account"
          element={
            <Box padding="32px" width="100%" overflowX="auto">
              <SettingsUserRoute />
            </Box>
          }
        />
        <Route path="/*" element={<Navigate to="/settings/my-account" />} />
      </Routes>
    </ValleyBankTemplate>
  );
};
